import {
  BufferGeometry,
  Camera,
  Material,
  Mesh,
  MeshBasicMaterial,
  OrthographicCamera,
  Scene,
  SphereGeometry,
  WebGLRenderer,
} from "three";
import { Quick3DPerspectiveCamera } from "../camera/quick3d-perspective-camera";
import * as Config from "../config/ViewerConfig";
import { AutoAttenuableState } from "../measurement/types";

export class AutoAttenuatableSphere extends Mesh {
  private pixelSize: number;
  private _defaultMaterial: Material;
  private _selectedMaterial: Material;
  private _hoveredMaterial: Material;
  private _defaultGeometry: BufferGeometry;
  private _selectedGeometry: BufferGeometry;
  private _hoveredGeometry: BufferGeometry;

  constructor(
    material: Material = new MeshBasicMaterial({ color: 0x0000ff }),
    pixelSize: number
  ) {
    const geometry = new SphereGeometry(Config.DEFAULT_SPHERE_RADIUS);
    super(geometry, material);

    this._defaultGeometry = new SphereGeometry(Config.DEFAULT_SPHERE_RADIUS);
    this._selectedGeometry = new SphereGeometry(Config.SELECTED_SPHERE_RADIUS);
    this._hoveredGeometry = new SphereGeometry(Config.HOVERED_SPHERE_RADIUS);

    this._defaultMaterial = material;
    this._selectedMaterial = new MeshBasicMaterial({
      color: Config.SELECTED_MEASUREMENT_COLOR,
      depthTest: false,
    });
    this._hoveredMaterial = new MeshBasicMaterial({
      color: Config.HOVERED_MEASUREMENT_COLOR,
      depthTest: false,
    });
    this.pixelSize = pixelSize;
    this.onBeforeRender = function (
      _ifcRenderer: WebGLRenderer,
      _nonClippingScene: Scene,
      camera: Camera
    ): void {
      let scale = 1;
      // if (camera instanceof OrizuruPerspectiveCamera) {
      //     const frustumWidth = camera.getFrustumWidthAtDistance(
      //         cameraPlane.distanceToPoint(this.position)
      //     );
      //     scale = 0.007 * frustumWidth;
      // } else
      const windowScale = Math.sqrt(
        (1280 * 720) / (window.screen.width * window.screen.height)
      );
      if (camera instanceof OrthographicCamera) {
        scale =
          ((camera.right - camera.left) / camera.zoom) * 0.02 * windowScale;
      }

      if (camera instanceof Quick3DPerspectiveCamera) {
        scale = this.position.distanceTo(camera.position) * 0.05 * windowScale;
      }

      this.scale.set(scale, scale, scale);
      this.updateMatrixWorld();
    };
  }

  public dispose(): void {
    if (this.parent) {
      this.parent.remove(this);
    }

    this.geometry?.dispose();

    if (Array.isArray(this.material)) {
      for (const m of this.material) {
        m.dispose();
      }
    } else {
      this.material?.dispose();
    }
    this.geometry = undefined as unknown as BufferGeometry;
    this.material = undefined as unknown as Material;
  }

  public setMaterialByState(state: AutoAttenuableState) {
    this.material = {
      default: this._defaultMaterial,
      hovered: this._hoveredMaterial,
      selected: this._selectedMaterial,
    }[state];
  }

  public setGeometryByState(state: AutoAttenuableState) {
    this.geometry = {
      default: this._defaultGeometry,
      hovered: this._hoveredGeometry,
      selected: this._selectedGeometry,
    }[state];
  }
}
